<template>
    <h2 class="afu-text-2xl afu-font-semibold afu-mb-6 afu-text-secondary">
        <slot />
    </h2>
</template>

<script>
    export default {
        name: 'PageHeading',

        data() {
            return {};
        },
    };
</script>
